import React from "react";
import {
  TiSocialFacebook,
  TiSocialTwitter,
  TiSocialPinterest,
  TiSocialLinkedin
} from "react-icons/ti";

import { Container, Row, Col } from "../Base/Layout";

import PageHeader from "../Base/PageHeader";

import BlogPageWrapper from "./blogSingle.style";

import ReactMarkdown from 'react-markdown'

const BlogSingle = ({post}) => {
  const shareUrl = (typeof window !== 'undefined') ? window.location.href : '';
  return (
    <BlogPageWrapper>
      <div className="single-post-wrapper">
        <Container>
          <Row>
            <Col>
              <div style={{maxWidth: '80%', margin: '0 auto'}}>
                <PageHeader
                  title={post.data.title}
                  categories={post.data.tags}
                  author={{ name: post.data.author, profile: "#" }}
                  />
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={12} lg={8} style={{margin: '0 auto'}}>
              <Row>
                <Col xs={12}>
                  <div className="single-post-block">
                    <div style={{padding: 4}}>
                      {/* <div className="markdown" dangerouslySetInnerHTML={{__html: post.content }} /> */}
                      <ReactMarkdown>{post.content}</ReactMarkdown>
                    </div>
                    <div className="post-info-block">
                      <div style={{marginLeft: 'auto'}} className="share">
                        <a href={`https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`} target="_blank">
                          <TiSocialFacebook />
                        </a>
                        <a href={`https://twitter.com/intent/tweet/?text=${post.data.title}&url=${shareUrl}`} target="_blank">
                          <TiSocialTwitter />
                        </a>
                        <a href={`https://pinterest.com/pin/create/button/?url=${shareUrl}&media=&description=`} target="_blank">
                          <TiSocialPinterest />
                        </a>
                        <a href={`https://www.linkedin.com/shareArticle?mini=true&url=${shareUrl}&title=${post.data.title}`} target="_blank">
                          <TiSocialLinkedin />
                        </a>
                        <span>:Share</span>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
            {/* <Col sm={12} lg={4}>
              <Sidebar />
            </Col> */}
          </Row>
        </Container>
      </div>
    </BlogPageWrapper>
  );
};

export default BlogSingle;